import React from 'react';
import { motion } from 'framer-motion';
import { projects } from '../../data';
import ProjectCard from './ProjectCard.jsx';
import { SectionWrapper } from '../../hoc';
import { styles } from '../../styles';
import { textVariant } from '../../utils/motion';
import { useTranslation } from 'react-i18next';

const Projects = () => {
  const { t } = useTranslation();

  const handleCardClick = (projectName) => {
    console.log(`Card clicked: ${projectName}`);
  };

  return (
    <>
      <motion.div variants={textVariant()}>
        <h2 className={`${styles.sectionText} text-center`}>
          {t('projects.title')}
        </h2>
      </motion.div>

      <div className="mt-20 flex flex-wrap justify-center gap-7">
        {projects.map((project, index) => (
          <div key={`project-wrapper-${index}`} className="w-[350px]">
            <ProjectCard
              index={index}
              {...project}
              onClick={() => handleCardClick(project.name)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Projects, 'projects');
